import { useTranslation } from 'react-i18next';

import { AlertDialog, Button } from '~/components';

type Props = {
  isLocked: boolean;
  loading?: boolean;
  onConfirm: () => void;
};

export const InvoiceConfirmEditDialog = ({ isLocked, loading, onConfirm }: Props) => {
  const { t } = useTranslation(['invoices']);

  return (
    <AlertDialog.Body status="danger">
      <AlertDialog.Title>{t('invoices:details.confirmEditModal.title')}</AlertDialog.Title>

      <AlertDialog.Description>
        {isLocked ? t('invoices:details.confirmEditModal.bodyLocked') : t('invoices:details.confirmEditModal.bodyPending')}
      </AlertDialog.Description>

      <AlertDialog.Actions>
        <Button emphasis="status" loading={loading} onClick={onConfirm}>
          {t('invoices:details.confirmEditModal.confirm')}
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
